/* eslint-disable */
import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Material UI table
import { MaterialReactTable } from "material-react-table";
import {
  Box,
  MenuItem,
  IconButton,
  TextField,
  InputAdornment,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Check";
import CancelIcon from "@mui/icons-material/Close";

import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import { commonHeaderLinkLists } from "helper/ClinicalManagementHelper/ClinicalManagementHelper";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import PrescriptionsHeader from "./Header/PrescriptionsHeader";
import {
  getDateFormatInSpanish,
  mergeListById,
} from "helper/Common/CommonHelper";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import SavePrescriptionPopup from "components/Common/Popup/SavePrescriptionPopup";
import { assetImages } from "constants";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import AssignUserModal from "components/Common/Modal/AssignUserModal";
import PrescriptionFilter from "./Popup/PrescriptionFilter";
import AddLabelModal from "components/Common/Modal/AddLabelModal";
import { removeTagHandler } from "helper/TagHelper/TagHelper";

const PrescriptionsListBody = () => {
  const { t } = useTranslation();

  const token = localStorage.getItem("token");
  const moduleAccess = localStorage.getItem("moduleaccess");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [isLoading, setIsLoading] = useState(false);
  const [prescriptionList, setPrescriptionList] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const [selectedPrescriptionIds, setSelectedPrescriptionIds] = useState([]);
  const [selectedPrescriptionId, setSelectedPrescriptionId] = useState(null);
  const [selectedTagId, setSelectedTagId] = useState(null);

  //json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  const [isFilterReset, setIsFilterReset] = useState(false);
  const [reloadData, setReloadData] = useState(false);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const [isDataReady, setIsDataReady] = useState(false);

  const [doctorObj, setDoctorObj] = useState(null);
  const [clinicObj, setClinicObj] = useState(null);

  const getDoctorOrLabtesterDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_DETAILS +
        `/${userInfo._id}` +
        `?token=${token}`;

      console.log("requestUrl in Doctor or Labtester details", requestUrl);

      const response = await getData(requestUrl);

      // console.log("response in user details", response);

      if (response.status && response.data) {
        const data = response.data;

        const userApiObj = {
          _id: data._id,
          company: data.company,
          name: data.name,
          surname: data.surname,
          email: data.email,
          position: data.position,
          address: data.address,
          city: data.city,
          state: data.state,
          country: data.country,
          zipcode: data.zipcode,
          phone: data.phone,
          rank: data.rank,
          costperhour: data.costperhour,
          mincostperhour: data.mincostperhour,
          taglist: data.tags,
          image: data.userimage,
          fullname: data.userfullname,
          rolestring: data.userrole?.label,
          label: data.userfullname,
          value: data._id,
        };

        if (userInfo.role.slug === "DOCTOR") {
          setDoctorObj(userApiObj);
        }
      }
    } catch (error) {
      console.log(error.message);
    } finally {
    }
  };

  const getProviderClinicList = async () => {
    try {
      const requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_COMPANY_LIST + `?token=${token}`;
      const response = await getData(requestUrl);

      console.log("response in getProviderClinics", response);

      if (response.status && response.data) {
        setClinicObj(response.data[0]);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get all prescriptions
  const getAllPrescriptions = async () => {
    try {
      setIsLoading(true);

      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_MEDICAL_DOCUMENT + `?token=${token}`;

      if (jsonFilterQuery.length > 0) {
        // Sanitize the jsonFilterQuery
        const sanitizedQuery = jsonFilterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
            };
          }
          return filter;
        });

        requestUrl += `&filters=${JSON.stringify(sanitizedQuery)}`;
      }

      console.log("requestUrl in get all prescriptions", requestUrl);

      const response = await getData(requestUrl);

      setIsLoading(false);

      // console.log("response", response);

      if (response.status) {
        setPrescriptionList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for update bulk prescription
  const updateBulkPrescriptionHandler = async () => {
    if (selectedPrescriptionIds.length > 0) {
      try {
        const prescriptionListToBeUpdate = prescriptionList
          .filter((item) => selectedPrescriptionIds.includes(item._id))
          .map((item) => {
            return {
              _id: item._id,
              name: item.name,
              provider: item.provider,
              testdate: item.testdate,
              resultdate: item.resultdate,
              referredby: item.referredby,
            };
          });

        let apiData = {
          medicaldocumentlist: prescriptionListToBeUpdate,
        };

        // console.log("apiData in update bulk prescription handler", apiData);

        let requestURL =
          url.API_BASE_URL +
          url.API_UPDATE_BULK_MEDICAL_DOCUMENT +
          `?token=${token}`;

        const response = await putData(requestURL, apiData);

        // console.log("response in update bulk prescription handler", response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setSelectedPrescriptionIds([]);
            setRowSelection({});
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one prescription");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //function for delete bulk prescription
  const deletePrescriptionHandler = async () => {
    if (selectedPrescriptionIds.length > 0) {
      try {
        const prescriptionListToBeDelete = prescriptionList.filter((item) =>
          selectedPrescriptionIds.includes(item._id)
        );

        let apiData = {
          medicaldocumentlist: prescriptionListToBeDelete,
        };

        let requestURL =
          url.API_BASE_URL +
          url.API_DELETE_BULK_MEDICAL_DOCUMENT +
          `?token=${token}`;

        const response = await putData(requestURL, apiData);

        console.log(response);

        if (response.status) {
          setMessageType("success");
          setTimeout(() => {
            setPrescriptionList((prevList) =>
              prevList.filter(
                (item) => !selectedPrescriptionIds.includes(item._id)
              )
            );

            setSelectedPrescriptionIds([]);
            setRowSelection({});
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one prescription");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //function for remove tag from prescription
  const removeTagFromPrescription = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_MEDICAL_DOCUMENT;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      if (data) {
        afterActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedPrescriptionId(null);
      }, 1000);
    }
  };

  //function for after any action
  const afterActionClose = (data = []) => {
    setTimeout(() => {
      setPrescriptionList((prevList) => mergeListById(prevList, data));
    }, 1000);
  };

  //function for reset
  const resetFilterData = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  // useEffect(() => {
  //   getAllPrescriptions();
  // }, []);

  useEffect(() => {
    if (
      userInfo?.role?.slug === "DOCTOR" ||
      userInfo?.role?.slug === "LAB_TECHNICIAN"
    ) {
      getDoctorOrLabtesterDetails();
    } else if (userInfo?.role?.slug === "CUSTOMER") {
      getProviderClinicList();
    }
  }, []);

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getAllPrescriptions();
      setIsDataReady(true);
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (reloadData) {
      getAllPrescriptions();
      setReloadData(false);
      setIsDataReady(true);
    }
  }, [reloadData]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: t("Actions"),
        Cell: ({ row }) => (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#savePrescriptionOffCanvas"
            aria-controls="savePrescriptionOffCanvas"
            onClick={() => {
              setSelectedPrescriptionId(row.original._id);
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        ),
        enableColumnActions: false, // Hides the column action icon
        enableColumnDragging: false, // Hides the move icon
        enableSorting: false,
      },
      {
        header: "Name",
        accessorKey: "name",
        size: 200,
      },
      //tags column
      {
        accessorKey: "tagstring",
        header: t("Tags"),
        size: 200,
        Cell: ({ row }) => (
          <div className="label-wrapper py-1">
            <div className="d-flex gap-2">
              <div
                className={
                  row.original.taglist.length > 0
                    ? "label-container flex-grow-1"
                    : "d-none"
                }
              >
                <ul
                  className="d-flex flex-wrap gap-2 m-0 p-0"
                  style={{ listStyle: "none" }}
                >
                  {row.original.taglist.map((tag, index) => (
                    <li key={index} className="d-inline-flex">
                      <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                        <span className="badge-text fs-xs fw-medium me-1">
                          {tag.title}
                        </span>
                        <Link
                          to="#"
                          className={`${
                            tag.moderator.toString() ===
                              userInfo._id.toString() ||
                            userInfo.role.slug === "ADMIN" ||
                            userInfo.role.slug === "SUPER_ADMIN"
                              ? "d-block"
                              : "d-none"
                          }`}
                          onClick={() => {
                            setSelectedPrescriptionId(row.original._id);
                            setSelectedTagId(tag._id);
                            removeTagFromPrescription(
                              [tag._id],
                              row.original._id
                            );
                          }}
                        >
                          {selectedTagId &&
                          selectedTagId === tag._id &&
                          selectedPrescriptionId &&
                          selectedPrescriptionId === row.original._id ? (
                            <div
                              className="spinner-border spinner-border-sm text-primary ms-1"
                              role="status"
                              style={{ height: "12px", width: "12px" }}
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            <span
                              className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                              style={{ cursor: "pointer" }}
                            >
                              cancel
                            </span>
                          )}
                        </Link>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <button
                className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
                style={{ width: "24px", height: "24px" }}
                data-bs-toggle="modal"
                data-bs-target="#addLabelModal"
                onClick={() => setSelectedPrescriptionIds([row.original._id])}
              >
                <span
                  className="material-symbols-outlined text-primary"
                  style={{ fontSize: "16px" }}
                >
                  add
                </span>
              </button>
            </div>
          </div>
        ),
      },
      {
        header: "Referred By",
        accessorKey: "doctorname",
        size: 200,
        Cell: ({ row }) => (
          <div
            className={
              row.original.doctorname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.doctorimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.doctorimage
              }
              alt="Babcock"
            />
            <p>
              <span className="d-block">{row.original.doctorname}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Assigned To",
        accessorKey: "assignedpersonname",
        Cell: ({ row }) => (
          <div
            className={
              row.original.assignedpersonname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.assignedpersonimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.assignedpersonimage
              }
              alt="Babcock"
            />
            <p>
              <span className="d-block">{row.original.assignedpersonname}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Provider",
        accessorKey: "clinicname",
        size: 200,
        Cell: ({ row }) => (
          <div
            className={
              row.original.clinicname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.clinicimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.clinicimage
              }
              alt="Babcock"
            />
            <p>
              <span className="d-block">{row.original.clinicname}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Diseases",
        accessorKey: "diseasescount",
      },
      {
        header: "Medications",
        accessorKey: "medicationscount",
      },
      {
        header: "Lab Tests",
        accessorKey: "laboratorytestscount",
      },
      {
        header: "Test Date",
        accessorKey: "testdate",
        Cell: ({ row }) => (
          <div className="joined border-bottom-0">
            <p className="d-flex align-items-center gap-2">
              <span className="d-block material-symbols-outlined icon-md">
                calendar_month
              </span>
              <span className="d-block">
                {getDateFormatInSpanish(row.original.testdate)}
              </span>
            </p>
          </div>
        ),
      },
      {
        header: "Result Date",
        accessorKey: "resultdate",
        Cell: ({ row }) => (
          <div className="joined border-bottom-0">
            <p className="d-flex align-items-center gap-2">
              <span className="d-block material-symbols-outlined icon-md">
                calendar_month
              </span>
              <span className="d-block">
                {getDateFormatInSpanish(row.original.resultdate)}
              </span>
            </p>
          </div>
        ),
      },
    ],
    [selectedPrescriptionId, selectedTagId, selectedPrescriptionIds] // Remove editingCell, editingValue dependencies
  );

  //initialize the column order
  const columnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ]; //array of column ids (Initializing is optional as of v2.10.0)

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    setSelectedPrescriptionIds(selectedIdsArray);
  }, [rowSelection]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    (moduleAccess.includes("MOD_CLINIC_MANAGEMENT") &&
      moduleAccess.includes("MOD_DOCTOR_PRESCRIPTION_LIST"))
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderLinkLists(t)}
            activeOption={t("Doctor Prescriptions")}
          />
          <div className="container-fluid px-lg-5">
            <PrescriptionsHeader
              reloadList={resetFilterData}
              selectedItemIds={selectedPrescriptionIds}
              updateBulkHandler={updateBulkPrescriptionHandler}
              jsonFilterQuery={jsonFilterQuery}
            />

            {isLoading || !isDataReady ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns}
                  data={prescriptionList}
                  enableGrouping // to enable grouping of column
                  enableRowSelection // enable showing checkbox in each row
                  getRowId={(row) => row._id}
                  onRowSelectionChange={setRowSelection}
                  state={{ rowSelection, columnOrder }}
                  initialState={{ rowSelection, columnOrder }} // to set the initial state of column order
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50, //make columns wider by default
                  }}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>

          {/* popup section */}
          <SavePrescriptionPopup
            selectedPrescriptionId={selectedPrescriptionId}
            setSelectedPrescriptionId={setSelectedPrescriptionId}
            afterActionClose={afterActionClose}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            doctorObj={doctorObj}
            clinicObj={clinicObj}
          />

          <AssignUserModal
            moduleName={"prescription"}
            selectedIds={selectedPrescriptionIds}
            onModalClose={() => {
              setRowSelection({});
              setSelectedPrescriptionIds([]);
            }}
            afterModalClose={afterActionClose}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
          />

          <PrescriptionFilter
            columnOrder={columnOrder}
            setJsonFilterQuery={setJsonFilterQuery}
            reloadList={resetFilterData}
            moduleSlug="prescriptionlist"
            isFilterReset={isFilterReset}
            setIsFilterReset={setIsFilterReset}
            columns={columns}
          />

          <DeleteWarningModal
            moduleName={"prescription"}
            onDelete={deletePrescriptionHandler}
            onCancelDelete={() => {
              setRowSelection({});
              setSelectedPrescriptionIds([]);
            }}
          />

          <AddLabelModal
            moduleName={"medicaldocument"}
            selectedIds={selectedPrescriptionIds}
            afterTagModalClose={afterActionClose}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            onModalClose={() => {
              setRowSelection({});
              setSelectedPrescriptionIds([]);
            }}
          />

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default PrescriptionsListBody;
